/*
 *
 * Form reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_COMPANIES_INFO_SUCCESS,
  GET_COMPANIES_INFO_WATCHER,
  GET_COMPANIES_SAVE_WATCHER,
  GET_COMPANIES_SAVE_SUCCESS,
  GET_COMPANIES_SAVE_FAILED,
  GET_COMPANY_WATCHER,
  GET_COMPANY_SUCCESS,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_WATCHER,
  DELETE_COMPANY_FAILED,
  USERS_COMPANY_WATCHER,
  USERS_COMPANY_SUCCESS,
  USERS_COMPANY_FAILED,
  USERS_SA_SWITCH_WATCHER,
  USERS_SA_SWITCH_SUCCESS,
  USERS_SA_SWITCH_FAILED,
  GET_USERS_SUCCESS,
  GET_USERS_WATCHER,
  VALIDATE_VISMA_PEOPLE_INFO_WATCHER,
  VALIDATE_VISMA_PEOPLE_INFO_SUCCESS,
  VALIDATE_VISMA_PEOPLE_INFO_FAILED,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_SUCCESS,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_FAILED,
  UPDATE_VALIDATE_VISMA_PEOPLE_REQUESTED,
  UPDATE_VALIDATE_VISMA_PEOPLE_STRUCTURE_REQUESTED,
  RESET_COMPANIES_INFO,
  RESET_VISMA_PEOPLE_VALIDATIONS,
  RESET_VISMA_PEOPLE_STRUCTURE_VALIDATIONS,
} from "./constants"

export const initialState = fromJS({
  optionsLoading: false,
  options: {
    sizes: [],
    collaborators: [],
    services: [],
    sectors: [],
    country: [],
  },
  saveLoading: false,
  currentCompanyLoading: false,
  currentCompany: {},
  deleteLoading: false,
  usersLoading: false,
  users: [],
  userSASwitch: false,
  companyUsersLoading: false,
  currentUsers: {},
  validateVismaPeopleInfoRequested: false,
  validateVismaPeopleInfo: {},
  validateVismaPeopleInfoLoading: false,
  validateVismaPeopleStructureRequested: false,
  validateVismaPeopleStructure: {},
  validateVismaPeopleStructureFeedback: [],
  validateVismaPeopleStructureLoading: false
})

function formReducer(state = initialState, action) {
  switch (action.type) {
    case GET_COMPANIES_INFO_WATCHER:
      return state.set("optionsLoading", true).set("options", {
        sizes: [],
        collaborators: [],
        services: [],
        sectors: [],
        country: [],
      })
    case GET_COMPANIES_INFO_SUCCESS:
      return state.set("optionsLoading", false).set("options", action.payload)

    case GET_COMPANIES_SAVE_WATCHER:
      return state.set("saveLoading", true)
    // .set('currentCompany', {})
    case GET_COMPANIES_SAVE_SUCCESS:
      return state
        .set("saveLoading", false)
        .set(
          "currentCompany",
          action.payload.data.result ? action.payload.data.result.company : {}
        )
    case GET_COMPANIES_SAVE_FAILED:
      return state.set("saveLoading", false)

    case GET_COMPANY_WATCHER:
      return state
        .set("optionsLoading", true)
        .set("currentCompanyLoading", true)
        .set("currentCompany", {})
    case GET_COMPANY_SUCCESS:
      return state
        .set("currentCompanyLoading", false)
        .set("currentCompany", action.payload)
    case DELETE_COMPANY_WATCHER:
      return state.set("deleteLoading", true)
    case DELETE_COMPANY_SUCCESS:
      return state.set("deleteLoading", false)
    case DELETE_COMPANY_FAILED:
      return state.set("deleteLoading", false)

    case USERS_COMPANY_WATCHER:
      return state.set("usersLoading", true).set("users", [])
    case USERS_COMPANY_SUCCESS:
      return state.set("usersLoading", false).set("users", action.payload)
    case USERS_COMPANY_FAILED:
      return state.set("usersLoading", false)

    case USERS_SA_SWITCH_WATCHER:
      return state.set("userSASwitch", true)
    case USERS_SA_SWITCH_SUCCESS:
      return state.set("userSASwitch", false)
    case USERS_SA_SWITCH_FAILED:
      return state.set("userSASwitch", false)
    case GET_USERS_WATCHER:
      return state
        .set("companyUsersLoading", true)
        .set("currentUsers", {})
    case GET_USERS_SUCCESS:
      return state
        .set("companyUsersLoading", false)
        .set("currentUsers", action.payload)
    case VALIDATE_VISMA_PEOPLE_INFO_WATCHER:
        return state.set('validateVismaPeopleInfoLoading', true)
    case VALIDATE_VISMA_PEOPLE_INFO_SUCCESS:
        return state
          .set('validateVismaPeopleInfoLoading', false)
          .set('validateVismaPeopleInfoRequested', true)
          .set('validateVismaPeopleInfo', action.payload)
    case VALIDATE_VISMA_PEOPLE_INFO_FAILED:
        return state
          .set('validateVismaPeopleInfoLoading', false)
          .set('validateVismaPeopleInfo', {})
    case VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER:
        return state.set('validateVismaPeopleStructureLoading', true)
    case VALIDATE_VISMA_PEOPLE_STRUCTURE_SUCCESS:
        return state
          .set('validateVismaPeopleStructureLoading', false)
          .set('validateVismaPeopleStructureRequested', true)
          .set('validateVismaPeopleStructure', action.payload)
          .set('validateVismaPeopleStructureFeedback', action.payload.data)
    case VALIDATE_VISMA_PEOPLE_STRUCTURE_FAILED:
        return state
          .set('validateVismaPeopleStructureLoading', false)
          .set('validateVismaPeopleStructure', {})
    case UPDATE_VALIDATE_VISMA_PEOPLE_REQUESTED:
        return state.set('validateVismaPeopleInfoRequested', action.payload)
    case UPDATE_VALIDATE_VISMA_PEOPLE_STRUCTURE_REQUESTED:
        return state.set('validateVismaPeopleStructureRequested', action.payload)
    case RESET_COMPANIES_INFO:
        return state.set('currentCompany', {}).set('validateVismaPeopleInfo', {}).set('validateVismaPeopleStructure', {})
    case RESET_VISMA_PEOPLE_STRUCTURE_VALIDATIONS:
        return state.set('validateVismaPeopleStructure', {})
          .set('validateVismaPeopleStructureFeedback', [])
          .set('validateVismaPeopleStructureRequested', false)
    case RESET_VISMA_PEOPLE_VALIDATIONS:
        return state.set('validateVismaPeopleInfo', {})
          .set('validateVismaPeopleStructure', {})
          .set('validateVismaPeopleStructureFeedback', [])
          .set('validateVismaPeopleInfoRequested', false)
    default:
      return state
  }
}

export default formReducer
